import React from 'react';
import { initializeGTM } from './trackingScriptInitialisers.mobiworkx';

export default function TrackingScriptsMobiworkx() {
  React.useEffect(() => {
    initializeGTM();
  }, []);
  return null;
}
